'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontStyle = function fontStyle(_ref) {
  var colorScheme = _ref.colorScheme,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.breadcrumbs.item.title;

  var fontSize = path.fontSize,
      lineHeight = path.lineHeight,
      fontWeight = path.fontWeight,
      textTransform = path.textTransform;


  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';font-weight:', ';text-transform:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, path.colorScheme[colorScheme].color, fontWeight, textTransform);
};

var state = function state(_ref2) {
  var active = _ref2.active,
      themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var stateKey = active ? 'active' : 'default';
  var path = theme.reactackle.components.breadcrumbs.item.title.state[stateKey];

  var textDecoration = path.textDecoration;


  var hoverTD = path.hover.textDecoration || textDecoration;

  return (0, _styledComponents.css)(['text-decoration:', ';li > *:hover &{text-decoration:', ';}li > *:focus &{text-decoration:', ';}'], textDecoration, hoverTD, path.focus.textDecoration || hoverTD);
};

var TitleStyled = exports.TitleStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TitleStyled'
})(['', ' ', ''], fontStyle, state);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-breadcrumbs/dist/BreadcrumbsItem/styles/TitleStyled.js
// module id = 553
// module chunks = 0